import { Input, TextArea, Dropdown } from './formInputs/index.jsx'
import {
  getEmailServiceInquiries,
  getEmailSalesInquiries,
  getEmailFutureScholar,
} from '../../../global/environments/config'

/* return true if valid */
const validators = {
  phone: (value) => {
    return value?.replaceAll(/[^\d]/g, '').length === 10
  },
  email: (value) => {
    return /^\S+@\S+\.\S+$/.test(value)
  },
  text: (value) => {
    return value?.trim().length > 0
  },
}

const ria = {
  strings: {
    formId: 'RiaContactForm',
    url: '/api/email',
    subtitle: ' ', // empty space to hide subtitle from BaseForm
    title: 'RIA Support',
    dataAnalyticsFormName: 'resources-support',
  },
  inputs: [
    {
      name: 'firstName',
      label: 'First name',
      type: 'text',
      required: true,
      component: Input,
      errorMessage: 'Please enter first name',
      validator: validators.text,
    },
    {
      name: 'lastName',
      label: 'Last name',
      type: 'text',
      required: true,
      component: Input,
      errorMessage: 'Please enter last name',
      validator: validators.text,
    },
    {
      name: 'email',
      label: 'Work email',
      type: 'email',
      required: true,
      component: Input,
      errorMessage: 'Please enter work email address',
      validator: validators.email,
    },
    {
      name: 'jobTitle',
      label: 'Job title',
      type: 'text',
      required: true,
      component: Input,
      errorMessage: 'Please enter job title',
      validator: validators.text,
    },
    {
      name: 'firmName',
      label: 'Firm name',
      type: 'text',
      required: true,
      component: Input,
      errorMessage: 'Please enter firm name',
      validator: validators.text,
    },
    {
      name: 'interest',
      label: 'I am interested in:',
      errorMessage: 'Please select from the dropdown',
      hideErrorIcon: true,
      type: 'select',
      required: true,
      component: Dropdown,
      options: [
        {
          value: '',
          disabled: true,
          selected: true,
          label: 'Select an option',
        },
        {
          value: 'Schedule a planning review',
          label: 'Schedule a planning review',
        },
        { value: 'Host a client seminar', label: 'Host a client seminar' },
        {
          value: 'Request a custom CE course',
          label: 'Request a custom CE course',
        },
        {
          value: 'Join upcoming webinars & events',
          label: 'Join upcoming webinars & events',
        },
        {
          value: 'Request investment product information',
          label: 'Request investment product information',
        },
        { value: 'Other', label: 'Other' },
      ],
      validator: validators.text,
    },
    {
      name: 'message',
      label: 'Message (optional)',
      type: 'text',
      required: false,
      component: TextArea,
    },
  ],
  columns: [
    ['firstName', 'lastName', 'email', 'jobTitle', 'firmName'],
    ['interest', 'message'],
  ],
}

const contactUs = {
  strings: {
    formId: 'ContactUsForm',
    fullName: 'Full name',
    email: 'Email address',
    phone: 'Phone number',
    message: 'Message',
    url: '/api/email',
  },
  defaultErrors: {
    fullName: null,
    email: null,
    phone: null,
    message: null,
  },
}

const emailContactRecipients = {
  default: {
    recipientEmail: getEmailServiceInquiries(),
    subject: 'Contacting for Help',
    type: 'Contact Us By Email',
  },
  service_inquiries: {
    recipientEmail: getEmailServiceInquiries(),
    subject: 'Contacting for Help',
    type: 'Service inquiries',
  },
  product_inquiries: {
    recipientEmail: getEmailSalesInquiries(),
    subject: 'Contacting for Help',
    type: 'Product inquiries',
  },
  sales_inquiries: {
    recipientEmail: getEmailSalesInquiries(),
    subject: 'Contacting for Help',
    type: 'Sales/prospecting questions',
  },
  ria_sales_inquiries: {
    recipientEmail: getEmailSalesInquiries(),
    subject: 'RIA Support',
    type: 'RIA Support',
  },
  '529_FS': {
    recipientEmail: getEmailFutureScholar(),
    subject: 'Contacting for Help',
    type: '529 plan service inquiries',
  },
}

const getFormConfig = (type) => {
  return {
    'Contact Us': contactUs,
    'Ria Contact': ria,
  }[type]
}

export { emailContactRecipients, ria, contactUs, getFormConfig }
